module.exports = __webpack_public_path__ + "img/361.4c380a5b.jpg";